import React from "react";
import { withTranslation } from 'react-i18next';
import { Contacts } from "./contacts";

class ContactsParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return <Contacts  {...this?.props} />;
    }
}

export default withTranslation('contacts')(ContactsParent);
